
import { v4 as uuidv4 } from 'uuid';
import {qtyProxy} from "../../../..";
import {apiUrls, errorMessages, fileTypeSupport, maxFileSize} from "../../../assets/config";
import {fabric} from "fabric";
import {
  appendElementWithId,
  compareArr, conversionToHex,
  getCurrentCanvas,
  getDrawableArea,
  getSelectedBrandingArea,
  getSelectedTechnique,
  hexToRgb,
  replaceCurrentElementWithNewId, rgbToHex,
  setLoader, uniqBy,
  validateNumericInput
} from "../../../helpers/helper";
import {CheckTechniqueGradientSupport, clickStepBtnHandler, removeBackgroundCheckbox} from ".";
import {CheckTechniqueSingleColor, GetSelectedTechnique} from "./techniqueBaseOperations";
import {alignToolsBtn} from "../components";
import Coloris from "@melloware/coloris";
import { AlignObjectPosition } from "./alignObjectPosition";
import { getSingleColorLogo, replaceColorCanvasApi } from "../../../canvasAPI/change-color";
const pxTommH = (px) => (getSelectedBrandingArea()?.detail_height * px) / getSelectedBrandingArea()?.height;
const pxTommW = (px) => (getSelectedBrandingArea()?.detail_width * px) / getSelectedBrandingArea()?.width;
const overlayImgScaleX = Number(getCurrentCanvas()?.overlayImgScaleX ?? 1);
const overlayImgScaleY = Number(getCurrentCanvas()?.overlayImgScaleY ?? 1);

function clearUploadInputValue() {
  const logoBtn = document.getElementById('uploadLogo') as HTMLButtonElement;
  if (!logoBtn) return;
  logoBtn.value = "";
}

export async function uploadLogo(event,libraryId) {
  const removeButton = document.getElementById('removeBackgroundFromLogo');
  const file = event;

  const requestObj = new FormData();
  requestObj.append("file", file);
  const removeBgData = removeButton.checked ? "True" : "False"
  requestObj.append("removeBackground", removeBgData);
  if (CheckTechniqueSingleColor()) {
    requestObj.append("removeBackground", 'True');
    requestObj.append("techniqueName", GetSelectedTechnique())
  }
  removeBackgroundCheckbox();
  setLoader(true);
  try {
    const response = await fetch(apiUrls.imageConvert, {
      method: "POST",
      body: requestObj,
    });
    const data = await response.json();
    const id = "id" + uuidv4().toString();
    const fileName = file?.name;
    if (!data.data.image) {
      alert(errorMessages.LOGO_NOT_PROPER);
      return
    }

    if (data.data.isGradient === "True" && CheckTechniqueGradientSupport() && !confirm(errorMessages.CONFIRMATION_GRADIENT_MESSAGE_TECHNIQUE)) {
        return;
    }
    const selectedTechnique= getSelectedTechnique();
    const replacedByColor = hexToRgb(selectedTechnique.selected_color)
    let logoImageUrl = data.data.image;
    if(selectedTechnique.is_single_color_selected){
      logoImageUrl = await  getSingleColorLogo(data.data.image,data.data.colors,replacedByColor);
    }

    addApiImageToCanvas(logoImageUrl, id,libraryId,selectedTechnique.is_single_color_selected);
    const preLogoList = qtyProxy?.logoList ?? [];
    qtyProxy["logoList"] = [
      ...preLogoList,
      { id: id,
        logoColors: selectedTechnique.is_single_color_selected ? [replacedByColor] : data.data.colors,
        imgUrl: data.data.image,
        imgName: fileName,
        isBackground: data.data.isBackground !== 0,
        removeBackground: false,
        isGradient: data.data.isGradient,
        isAdjustPadding: false,
        hasBackground: data.data.isBackground !== 0,
        libraryId
      },
    ];
    clearUploadInputValue();
  } catch (error) {
    alert(errorMessages.SERVER_ERROR);
    removeBackgroundCheckbox();
    setLoader(false);
  }
}

export function validateImage(file) {
  if (file) {
    if (fileTypeSupport.includes(file.type)) {
      const size = file.size / 10024 / 10024;
      if (size > maxFileSize) {
        clearUploadInputValue();
        alert(errorMessages.LOGO_FILE_GREATER);
        return false;
      }
      return true;
    }
    clearUploadInputValue();
    alert(errorMessages.LOGO_FORMATE_ISSUE);
    return false;
  }
  return false;
}

export function updateAngleText(object) {
  const logoRotationDegree = document.querySelectorAll(".logoRotationDegree") 
  logoRotationDegree.forEach((el: HTMLInputElement)=>{
    el.value = object.angle.toFixed(0)
  })
}

export function handleRotation(){
  const logoRotationDegree = document.querySelectorAll(".logoRotationDegree");
  logoRotationDegree.forEach((el)=>{
    el.addEventListener("keydown",validateNumericInput);
    el.addEventListener('change',(e)=> {
      let tempAngle = +e.target.value;
      if(!tempAngle) tempAngle = 0;
      const activeCanvasObj = getCurrentCanvas()?.getActiveObjects()[0];
      activeCanvasObj.rotate(tempAngle)
      updateAngleText(activeCanvasObj)
      getCurrentCanvas().fire("object:modified");
      getCurrentCanvas().renderAll();
    })
  })
}

const addApiImageToCanvas = (url, id,libraryId, isSingleColorSelected) => {
  const imgURL = isSingleColorSelected ? url : apiUrls.convertedImage.concat(url);
  fabric.Image.fromURL(imgURL, function (img) {
    if (getCurrentCanvas()) {
      const image = img.set({
        objectCaching: false,
        id: id,
        libraryId
      });

      image.setControlsVisibility({ mt: false,ml: false, mr: false, mb : false })

      const editableArea = getDrawableArea();
      // Resize the image to fit within the canvas
      if (img.width > editableArea.width || img.height > editableArea.height) {
        let scale =
          Math.min(
            (editableArea.width) / img.width,
            (editableArea.height) / img.height
          );
        img.scale(+scale.toFixed(2));
      }

      // Calculate top and left positions to center the image within the drawable area
      const top =
        editableArea.top + (editableArea.height - img.getScaledHeight()) / 2;
      const left =
        editableArea.left + (editableArea.width - img.getScaledWidth()) / 2;

      image.set({
        top: top,
        left: left,
      });

      getCurrentCanvas().add(image);
      setLoader(false);
      getCurrentCanvas().setActiveObject(image);
      getCurrentCanvas().renderAll();
    }
  }, {crossOrigin: "Anonymous"});
};

export function colorSelectionHandle() {
  const colorPicker = document.querySelectorAll('.color-picker');
  if (!colorPicker) return;

  const activeCanvas =  getCurrentCanvas()?.getActiveObject();
  const colorSwatches = qtyProxy?.logoList?.find((logo) => logo.id === activeCanvas.id)?.logoColors?.map((color) =>
                        rgbToHex(color[0], color[1], color[2]));

  colorPicker.forEach((picker, index) => {
    const colorInput = document.getElementById(`color-${index}`);
    const selectedTechnique= getSelectedTechnique()
    if (selectedTechnique.is_single_color_selected) {
      picker.classList.add('disabled');
      return;
    }
    picker.addEventListener('click', () => {
      const selected = document.querySelector('.color-picker.selected');
      if (selected) selected.classList.remove('selected');

      picker.classList.add('selected');
    });
    Coloris.init();
    Coloris({
      parent: '.color-selector',
      el: `#color-${index}`,
      theme: 'pill',
      alpha: false,
      format: 'rgb',
      formatToggle: true,
      closeButton: true,
      closeLabel: 'Ok',
      swatches: colorSwatches,
    });
    addTextToColorisPicker();
    colorInput.addEventListener('change', () => {
      const previousColor = document.querySelectorAll('.color-picker')[index].style.backgroundColor;
      qtyProxy['oldColor'] = previousColor.replace("rgb(", "").replace(")","");
      onChangeLogoColor(index);
    });
  });
}

function updateListOfColors() {
  const newSelectedLogo = {...qtyProxy?.selectedLogo};
  const oldColor = qtyProxy?.oldColor?.split(",");
  newSelectedLogo?.logoColors.forEach((el, index) => {
    if (compareArr(el, oldColor)) {
      if (qtyProxy?.newColor) newSelectedLogo.logoColors[index] = [...qtyProxy.newColor];
      if (!qtyProxy?.newColor) delete newSelectedLogo.logoColors[index];
    }
  });
  newSelectedLogo.logoColors = uniqBy(newSelectedLogo.logoColors, JSON.stringify)
  qtyProxy['selectedLogo'] = newSelectedLogo;
  const logoList = JSON.parse(JSON.stringify(qtyProxy?.logoList));
  const index = logoList?.findIndex((el) => el.id === newSelectedLogo.id);
  logoList[index] = newSelectedLogo;
  qtyProxy['logoList'] = JSON.parse(JSON.stringify(logoList));
  delete qtyProxy.newColor;
  colorContainerHtmlRender();
   getCurrentCanvas().fire("object:modified");
   getCurrentCanvas().renderAll();
}

function setUpdatedImage(imageName, colorChange = true) {
  let imgURL;
  const logoUrl = qtyProxy?.selectedLogo;
  if(colorChange){
    imgURL = imageName;
    logoUrl['canvasImgUrl'] = imageName;
  }else {
    imgURL = apiUrls.convertedImage.concat(imageName);
    logoUrl['imgUrl'] = imageName;
  }

  const activeCanvasObj =  getCurrentCanvas()?.getActiveObjects()[0];
  activeCanvasObj.setSrc(imgURL, function () {
     getCurrentCanvas().renderAll();
    setLoader(false);
    updateListOfColors();
  }, {crossOrigin: "Anonymous"});
}

function onChangeLogoColor(index) {
  const colorInput = document.getElementById(`color-${index}`) as HTMLInputElement;
  if (!colorInput) return;
  const replacedByColorValue = conversionToHex(colorInput.value);
  qtyProxy['newColor'] = hexToRgb(replacedByColorValue);
  const newColorImageUrl = replaceColorCanvasApi(qtyProxy?.oldColor.split(",").map(Number), qtyProxy?.newColor)
  setUpdatedImage(newColorImageUrl)
}

export function logoDimensionHandler() {
  const activeCanvasObj = getCurrentCanvas()?.getActiveObjects()[0];
  const width = document.getElementById('logoWidth');
  const height = document.getElementById('logoHeight');

  // Add the event listener for keydown to both width and height inputs
  width.addEventListener("keydown", validateNumericInput);
  height.addEventListener("keydown", validateNumericInput);

  width.addEventListener('change', (event) => {
    let tempWidth = +event.target.value
    if(tempWidth === 0){
      tempWidth = 1
    }
    const value = tempWidth * event.target.getAttribute("data-px") ;
    const previousValue = [...getCurrentCanvas().viewportTransform];
    getCurrentCanvas().setViewportTransform([1, 0, 0, 1, 0, 0]);
    const newScaleX = +value/+activeCanvasObj.width;
    activeCanvasObj.scale(newScaleX);
    height.value = Math.ceil(pxTommH((activeCanvasObj?.getScaledHeight())/overlayImgScaleY));
    getCurrentCanvas().setViewportTransform(previousValue);
    getCurrentCanvas().fire("object:modified");
    getCurrentCanvas().renderAll();
  });
  height.addEventListener('change', (event) => {
    let tempHeight = +event.target.value
    if(tempHeight === 0){
      tempHeight = 1
    }
    const value = tempHeight * event.target.getAttribute("data-px") ;
    const previousValue = [...getCurrentCanvas().viewportTransform];
    getCurrentCanvas().setViewportTransform([1, 0, 0, 1, 0, 0]);
    const newScaleY = +value/+activeCanvasObj.height;
    activeCanvasObj.scale(newScaleY);
    width.value = Math.ceil(pxTommW((activeCanvasObj?.getScaledWidth())/overlayImgScaleX));
    getCurrentCanvas().setViewportTransform(previousValue);
     getCurrentCanvas().fire("object:modified");
    getCurrentCanvas().renderAll();
  });
  handleRotation();
}

async function removeButtonHandle(event) {
  qtyProxy['selectedLogo']['removeBackground'] = event.target.checked;
  qtyProxy['selectedLogo']['isBackground'] = !qtyProxy?.selectedLogo?.isBackground;
  const reqObject = {
    fileName: qtyProxy?.selectedLogo?.imgUrl,
    action: event.target.checked ? 'remove' : 'add',
    bgRGB: event.target.checked ? '' : qtyProxy?.backgroundColor?.toString()
  }
  const headers = new Headers();
  headers.append("Content-Type", "application/json");
  setLoader(true);
  try {
    const response = await fetch(apiUrls.backgroundRemove, {
      method: "POST",
      headers: headers,
      body: JSON.stringify(reqObject),
    });
    const data = await response.json();
    qtyProxy['backgroundColor'] = data?.data?.bgRGB;
    if (event.target.checked) {
      qtyProxy['oldColor'] = data?.data?.bgRGB?.toString();
    } else {
      const logoUrl = qtyProxy?.selectedLogo;
      logoUrl['logoColors']?.unshift([...qtyProxy['oldColor'].split(',')]);
      qtyProxy['newColor'] = [...qtyProxy['oldColor'].split(',')];
    }
    setUpdatedImage(data.data.image, false);
  } catch (error) {
    alert(errorMessages.SERVER_ERROR);
    setLoader(false);
  }
}

export function checkAllowedLogo() {
  const toastElement = document.getElementById("toastMessage");
  const selectedTechnique= getSelectedTechnique()
  if(!toastElement) return;
  const activeObject =  getCurrentCanvas()?.getActiveObject();
  const totalColor: number = qtyProxy?.logoList?.find((logo) => logo.id === activeObject?.id)?.logoColors?.length || 0;
  let _html = `<div> </div>`;
  toastElement.style.display = "none";
  if(totalColor && totalColor > selectedTechnique?.selected_color_count && !selectedTechnique.is_single_color_selected && selectedTechnique?.selected_color_count !== 0) {
    _html = `<div class="bg-warning">
            This logo has ${totalColor} colors but only ${selectedTechnique?.selected_color_count} colors is allowed.
        </div>`;
        toastElement.style.display = "block";
  }
  replaceCurrentElementWithNewId('toastMessage', _html);
}

export function addTextToColorisPicker (){
  const HTMLToAdd = `
  <label>Colors From The Logo</label>
  `
  appendElementWithId("clr-swatches",HTMLToAdd)
}

export function colorContainerHtmlRender() {
  const activeCanvasObj =  getCurrentCanvas()?.getActiveObjects()[0];
  const width = Math.ceil(pxTommW((activeCanvasObj?.getScaledWidth())/overlayImgScaleX));
  const height = Math.ceil(pxTommH((activeCanvasObj?.getScaledHeight())/overlayImgScaleY));
  const pxWidth = (activeCanvasObj?.getScaledWidth())
  const pxHeight = (activeCanvasObj?.getScaledHeight());
  const logoList = JSON.parse(JSON.stringify(qtyProxy?.logoList));
  const selectedLogo = logoList.find(
      (logo) => logo.id === activeCanvasObj.id
  );
  qtyProxy['selectedLogo'] = selectedLogo;

  const logoScaleForX = pxWidth/ width;
  const logoScaleForY = pxHeight/ height;
  const logoRotation = activeCanvasObj.angle.toFixed(0);

  const colorListHtml = `
    <div class="logo-configuration">
      <div class="color-container">
          <p class="logo-color-title">Logo Colors: </p>
           ${selectedLogo?.logoColors.map((color, index) => {
            const rgbColor = `rgb(${color[0]}, ${color[1]}, ${color[2]})`;
            return `
               <div class="color-selector">
                  <label for="color-${index}" class="color-picker" style="background-color: ${rgbColor}">
                  <div class="icon-edit-wrapper">
                  <svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 512 512" fill="#FFFFFF">
                  <title></title>
                  <g id="icomoon-ignore">
                  </g>
                  <path d="M432 0c44.182 0 80 35.817 80 80 0 18.010-5.955 34.629-16 48l-32 32-112-112 32-32c13.371-10.045 29.989-16 48-16zM32 368l-32 144 144-32 296-296-112-112-296 296zM357.789 181.789l-224 224-27.578-27.578 224-224 27.578 27.578z"></path>
                  </svg>
                  </div></label>
                  <input type="text" id="color-${index}"                   
                  class="logo-color logo-color-${index}" name="color-group" value="${rgbToHex(color[0], color[1], color[2])}">
                 
              </div>` ;
            }).join(" ")}   
      </div>
      <div id="toastMessage"> </div>
      <div class="logo-dimensions">
          <div class="input-group">
              <label for="logoWidth">Logo width: </label>
              <input min="1"  type="number" id="logoWidth" value="${width}" data-px="${logoScaleForX}"/>
              mm
          </div>
          <div class="input-group">
              <label for="logoHeight">Logo height: </label>
              <input min="1" type="number" id="logoHeight" value="${height}" data-px="${logoScaleForY}"  placeholder="" />
              mm
          </div>
      </div>
       <div class="input-group logo-rotation-wrapper">
            <label for="logoRotationDegree">Angle of Rotation: </label>
            <input min="1"  type="number" id="logoRotationDegree" class="logoRotationDegree" value="${logoRotation}" />
      </div>
      ${AlignObjectPosition()}
    </div>
      `;
  replaceCurrentElementWithNewId('colorContainer', colorListHtml);
  colorSelectionHandle();
  logoDimensionHandler();
  alignToolsBtn();
}

const onLogoChangeEvent = () => {
  const activeCanvasObj =  getCurrentCanvas()?.getActiveObjects()[0];
  const container = document.getElementById("colorContainer");
  const summaryElement = document.getElementById("logo-summary-wrapper");
  if (activeCanvasObj && activeCanvasObj?.type === 'image') {
    colorContainerHtmlRender();
    container.classList.remove('hidden');
    summaryElement.classList.add('hidden');
    clickStepBtnHandler(0);
  } else {
    container.classList.add('hidden');
    summaryElement.classList.remove('hidden');
  }
  checkAllowedLogo();
};

export const logoSelectionEventHandler = () => {
  getCurrentCanvas().off("selection:updated", onLogoChangeEvent);
  getCurrentCanvas().off("selection:created", onLogoChangeEvent);
  getCurrentCanvas().off("selection:cleared", onLogoChangeEvent);
  getCurrentCanvas().off('object:modified', onLogoChangeEvent);
  getCurrentCanvas().off('object:rotating', onLogoChangeEvent);
  getCurrentCanvas().off('object:modified', onLogoChangeEvent);

  getCurrentCanvas().on("selection:updated", onLogoChangeEvent);
  getCurrentCanvas().on("selection:created", onLogoChangeEvent);
  getCurrentCanvas().on("selection:cleared", onLogoChangeEvent);
  getCurrentCanvas().on('object:modified', onLogoChangeEvent);

  getCurrentCanvas()?.on('object:rotating', function (e) {
  updateAngleText(e.target);
  });

  getCurrentCanvas()?.on('object:selected', function (e) {
    updateAngleText(e.target);
  });
};

export function initUploadLogoButton() {
  const toolBtn = document.getElementById("openLogoLibrary");
  if (!toolBtn) return;
  logoSelectionEventHandler();
}

export const hideLogoContainerHandler = () => {
  const container = document.getElementById("colorContainer");
  container.classList.add('hidden');
}
